import Vue from 'vue';
import Vuex from 'vuex';
import moment from 'moment';

// modules
import vuexTable from '@/hardware/VuexTable';
import users from '@/components/Users';
import syndicates from '@/components/Syndicates';
import coowners from '@/components/Syndicates/Syndicate/Coowners';
import accounts from '@/components/Syndicates/Syndicate/Accounts';
import transactions from '@/components/Syndicates/Syndicate/Transactions';
import reports from '@/components/Syndicates/Syndicate/Reports';
import dashboard from '@/components/Syndicates/Syndicate/Dashboard';
import budgets from '@/components/Syndicates/Syndicate/Budget';
import events from '@/components/Syndicates/Syndicate/Information/Calendar';
import news from '@/components/Syndicates/Syndicate/Information/News';
import companies from '@/components/Syndicates/Syndicate/Companies';
import questions from '@/components/Syndicates/Syndicate/Forum';
import notices from '@/components/Syndicates/Syndicate/Information/Notices';
import faqs from '@/components/Syndicates/Syndicate/Information/FAQs';
import agmPresence from '@/components/Syndicates/Syndicate/Reports/AGM';
import BankStatements from '../components/Syndicates/Syndicate/BankStatement';
import SuggestedPF from '../components/Syndicates/Syndicate/SuggestedPF';
import links from '../components/Syndicates/Syndicate/Links';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';

if (!localStorage.getItem('sidebarCollapsed')) {
  localStorage.setItem('sidebarCollapsed', false);
}
Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const state = {
  authenticated: false,
  currentUser: false,
  userPFCont: false,
  loading: false,
  formLoading: false,
  error: false,
  success: false,
  fiscalYear: moment().format('YYYY-MM-DD'),
  sidebarCollapsed: (localStorage.getItem('sidebarCollapsed') === 'true'),
};

export default new Vuex.Store({
  state,
  actions,
  getters,
  mutations,
  modules: {
    vuexTable,
    users,
    syndicates,
    coowners,
    accounts,
    transactions,
    reports,
    dashboard,
    budgets,
    events,
    news,
    companies,
    questions,
    notices,
    faqs,
    agmPresence,
    BankStatements,
    SuggestedPF,
    links,
  },
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js